import * as React from 'react';
import {Grid, Typography, Divider, Tooltip} from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

export default function FieldView3({label, value, color,fontSize, fontColor}) {
  
  return (
    <Grid item sx={{ width: '100%', alignItems: "flex-start" }}>
      <Grid container justifyContent="flex-start" direction="row" alignItems="flex-start" sx={{ width: '100%' }}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ borderRadius: 3, wordBreak: 'break-word', overflowWrap: 'break-word', textAlign: 'left', alignItems: 'flex-start' }}>
          <Typography color="textSecondary" variant="h6" sx={{ fontSize: 12 }}>{label}</Typography>
          <Typography sx={{ color: 'primary.darker', fontWeight: 'light', fontSize:fontSize?fontSize: 12 }}>{value}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}